import React, { Component } from 'react';
import opensea_icon from '../../assets/img/icons/opensea.png';

import MintButton from './MintButton';

export default class BannerContent extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="banner__content--wrap">
            <h2 className="banner--title">Collect Your <span>Digital Assets</span> NFTs</h2>
            <p>Marketplace for monster character collections non fungible token NFTs.</p>
            <div className="banner__btn--wrap">
                <MintButton/>
                <a href="https://testnets.opensea.io/collection/neka-nfts-collection" className="btn opensea__btn" target="_blank" rel="noreferrer"><img src={opensea_icon} alt="icon" />OPENSEA</a>
            </div>
        </div>
      </React.Fragment>
    )
  }
}
